import { Box, Container, Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f8f9fa',
                borderTop: '1px solid #e0e0e0',
                py: 6,
                mt: 'auto',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Company Info */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{ fontWeight: 'bold', color: '#3f4fe6' }}
                        >
                            Puppet Interview
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                marginBottom: '16px',
                            }}
                        >
                            Revolutionizing research with tech-powered puppet interviews for child
                            studies.
                        </Typography>
                        {/* <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Link href="mailto:contact@puppetinterview.com" color="inherit">
                                <EmailIcon
                                    sx={{ color: '#666', '&:hover': { color: '#3f4fe6' } }}
                                />
                            </Link>
                            <Link
                                href="https://twitter.com/puppetinterview"
                                color="inherit"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <TwitterIcon
                                    sx={{ color: '#666', '&:hover': { color: '#3f4fe6' } }}
                                />
                            </Link>
                            <Link
                                href="https://linkedin.com/company/puppetinterview"
                                color="inherit"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <LinkedInIcon
                                    sx={{ color: '#666', '&:hover': { color: '#3f4fe6' } }}
                                />
                            </Link>
                        </Box> */}
                    </Grid>

                    {/* Product Links */}
                    {/* <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                            Product
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Features
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Pricing
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Demo
                            </Link>
                            <Link
                                href="/request-access"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Get Started
                            </Link>
                        </Box>
                    </Grid> */}

                    {/* Resources */}
                    {/* <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                            Resources
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Documentation
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Research
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Case Studies
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Support
                            </Link>
                        </Box>
                    </Grid> */}

                    {/* Company */}
                    {/* <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                            Company
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                About
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Team
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Careers
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Contact
                            </Link>
                        </Box>
                    </Grid> */}

                    {/* Legal */}
                    {/* <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                            Legal
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                Terms of Service
                            </Link>
                            <Link
                                href="https://puppetinterview.com"
                                color="text.secondary"
                                sx={{ textDecoration: 'none', '&:hover': { color: '#3f4fe6' } }}
                            >
                                COPPA Compliance
                            </Link>
                        </Box>
                    </Grid> */}
                </Grid>

                <Divider sx={{ my: 4 }} />

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        © {currentYear} Puppet Interview. All rights reserved.
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        Made with ❤️ for researchers worldwide
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}
